// auto-generated
export const APP_VERSION = '1.2.0';
